import { SmartTagErrorModel } from "../../smart-tags/model/smartTag.model";

/**
 * Model for Report Image
 */
export class ReportImageModel {
	public selectedContiguousRoom: any;

	constructor() {
		this.selectedContiguousRoom = null;
	}
}

export class ReportImageTargetPath {
	public jsonPath?: string;
	public error?: SmartTagErrorModel;

	constructor(jsonPath: string = null) {
		this.jsonPath = jsonPath;
	}

}
